@import (reference) '../../../../constants/spacing.module.less';

.job-theme(@border-color, @background) {
  width: fit-content;
  border-radius: 1px;
  border-top: 1px solid @border-color;
  border-right: 1px solid @border-color;
  border-bottom: 1px solid @border-color;
  border-left: 8px solid @border-color;
  background: @background;
}

.job-error {
  .job-theme(var(--red-600), var(--red-200));
}

.job-running {
  .job-theme(var(--grey-500), var(--grey-300));
}

.job-success {
  .job-theme(var(--green-300), var(--green-200));
}

.job-title {
  color: var(--grey-900);
  line-height: 16px;
  padding: @space-4 @space-16;
}
